// The Utils file sets up the local storage so although none of the exports are used we still need to require it.
const Utils = require("common/Utils");
const BrowserLocaleDetector = require("client_config/BrowserLocaleDetector");

function parseQueryParams() {
    var queryParams = {};
    var queryString = new RegExp("\\?.*").exec(document.location.href);

    if (queryString != null) {
        var params = queryString[0].substring(1).split(/&|;/);

        for (var i = 0; i < params.length; i++) {
            var parts = params[i].split("=");
            queryParams[parts[0]] = decodeURIComponent(parts[1]);
        }
    }
    return queryParams;
}

$(document).ready(function() {
    var detector = {};
    BrowserLocaleDetector.call(detector).then(function() {
        //  Set up correct language using the client
        $.i18n.init({
            ns : {namespaces : ["common", "web"]},
            resGetPath : "i18n/{lng}/{ns}.json",
            fallbackLng : "en",
            lng : detector.getLanguage(),
            useCookie : false,
            nsseparator : "::",
            keyseparator : ":",
            getAsync : false,
            interpolationPrefix : "{",
            interpolationSuffix : "}",
            useDataAttrOptions : true
        });

        // Update the text to be displayed
        var queryParams = parseQueryParams();
        var code = queryParams["code"];
        document.title = $.t("common::error.title");
        $("#errorHeading").text($.t("common::error.title"));
        $("#loginRequirementsMessage").text($.t("web::" + code + ".message", {defaultValue : $.t("common::errorPage.message")}));
    });
});



//////////////////
// WEBPACK FOOTER
// ./error-main.js
// module id = 0
// module chunks = 1